// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29FYf","controls":"styles_controls__31LfH","charLimit":"styles_charLimit__20v1t","input":"styles_input__1EZBk","send":"styles_send__30zgQ"};